// src/components/CanonicalCleanup.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function CanonicalCleanup() {
  const { pathname } = useLocation();

  useEffect(() => {
    // react-helmet-async tags its own elements with data-rh.
    // Remove any canonical / og:url / twitter:url it does NOT own,
    // so the browser's native Share button can't grab a stale URL.
    document
      .querySelectorAll(
        'link[rel="canonical"]:not([data-rh]), ' +
        'meta[property="og:url"]:not([data-rh]), ' +
        'meta[name="twitter:url"]:not([data-rh])'
      )
      .forEach((el) => el.remove());
  }, [pathname]);

  return null;
}